<template>
  <v-icon
    :class="{ 'updating-status' : state }"
    @click="handleClick"
  >
      mdi-refresh
  </v-icon>
</template>

<script>

export default {
  name: 'RefreshLoader',
  props: {
    item: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      state: false
    }
  },
  mounted() {
    window.EventBus.$on("jobRefreshComplete", this.handleEvent);
  },
  methods: {
    handleClick() {
      this.state = !this.state;
      this.$emit('loaderClicked', this.item);
    },
    handleEvent() {
      this.state = false;
    }
  }
}
</script>

<style lang="scss" scoped>
  .updating-status {
        animation-name: spin;
        animation-duration: 750ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear; 
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }
</style>